import { apiCallWithoutToken } from "./apiService";
import { BIO_LEAD_FORM } from "@/constants/v2/endPoints";

export const submitBioLead = (slug, body) =>
  apiCallWithoutToken(BIO_LEAD_FORM.replace(":slug", encodeURIComponent(slug)), "POST", body);

export const recordBioContact = (slug, body) =>
  apiCallWithoutToken(
    BIO_LEAD_FORM.replace(":slug", encodeURIComponent(slug)).replace(/buyer-form$/, "contacts"),
    "POST",
    body,
  );

const bioPath = (slug, path) =>
  BIO_LEAD_FORM.replace(":slug", encodeURIComponent(slug)).replace(/buyer-form$/, path);

export const sendBioMessage = (slug, body) => apiCallWithoutToken(bioPath(slug, "messages"), "POST", body);

export const confirmBioMessage = (token) =>
  apiCallWithoutToken(BIO_LEAD_FORM.replace(/agents\/:slug\/buyer-form$/, "messages/confirm"), "POST", { token });
